/**
 * Các loại kết quả validate trả về lỗi
 */
export default {
  /**
   * Lỗi
   * Hiển thị thông báo và dừng lại
   */
  Error: 0,
  /**
   * Cảnh báo - cần xác nhận
   * Hiển thị confirm có tiếp tục xử lý không
   */
  Warning: 1,

  /**
   * Lỗi phát sinh dữ liệu
   */
  Generation: 3,
};
